import { useCallback, useState } from 'react';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { VehicleObject } from '../../../types/myVehiclesType';

interface Props {
  token?: string;
  licensePlateNumber: string;
}

interface ReturnType {
  vehicleInResponse?: VehicleObject;
  lookup: ({ token, licensePlateNumber }: Props) => void;
  isLoading: boolean;
  error: boolean;
}

export const useVehicleSearch = (): ReturnType => {
  const [vehicleInResponse, setVehicleInResponse] = useState<VehicleObject | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const vehicleSearch = useCallback(
    async (licensePlateNumber: string) => {
      if (licensePlateNumber) {
        setIsLoading(true);
        try {
          const res = await apiClient.get<VehicleObject>(ApiType.apimMembershipApi, {
            url: ApiPaths[ApiType.apimMembershipApi].vehiclesSearch(licensePlateNumber),
          });

          setIsLoading(false);
          setError(false);
          setVehicleInResponse(res.data);
        } catch (e) {
          setIsLoading(false);
          setError(true);
        }
      }
      return () => {};
    },
    [setIsLoading, setError, setVehicleInResponse],
  );

  const lookup = useCallback(
    ({ licensePlateNumber }: Props) => {
      vehicleSearch(licensePlateNumber);
    },
    [vehicleSearch],
  );

  return { vehicleInResponse, lookup, isLoading, error };
};
